module.exports = __webpack_public_path__ + "static/toolsBg-5dd9bd642f2d6747c917c7201c4c8fa0.png";